import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SplashScreen from './SplashScreen';

const PrivateRoute = ({ children, allowedRoles, allowedTypes }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <SplashScreen />;
  }

  if (!user) {
    // Se estiver tentando acessar PDV, redirecionar para login PDV
    if (location.pathname.startsWith('/pdv')) {
      return <Navigate to="/pdv/login" replace />;
    }
    // Se estiver tentando acessar Garçom, redirecionar para login Garçom
    if (location.pathname.startsWith('/garcom')) {
      return <Navigate to="/garcom/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // Se for operador_caixa tentando acessar /admin, redirecionar para PDV
  if (user.tipo === 'operador_caixa' && location.pathname.startsWith('/admin')) {
    return <Navigate to="/pdv" replace />;
  }

  // Se for garçom tentando acessar /admin, redirecionar para /garcom
  if (user.tipo === 'garcom' && location.pathname.startsWith('/admin')) {
    return <Navigate to="/garcom" replace />;
  }

  // Se tiver roles permitidos especificados, verificar
  const allowed = allowedRoles || allowedTypes;
  console.log('🔐 PrivateRoute - User:', user?.tipo, 'Path:', location.pathname, 'Allowed:', allowed || 'Todos os usuários autenticados');
  if (allowed && !allowed.includes(user.tipo)) {
    if (user.tipo === 'operador_caixa') {
      return <Navigate to="/pdv" replace />;
    }
    if (user.tipo === 'garcom') {
      return <Navigate to="/garcom" replace />;
    }
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;

